// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:54:44

export default {
  "id": "air-block",
  "slug": "air-block",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f5698676f9854e9c89ed539904afa415-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f5698676f9854e9c89ed539904afa415/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Air Block",
      "description": "Jump, Place Blocks, and Conquer Challenging Levels!\n\nIn Air Block, use quick reflexes and smart block placement to overcome obstacles and enemies. With limited blocks per level, every move counts! Avoid saws, spikes, and unlock doors to progress—plus, grab those bananas if you can!\n\nGame Modes:\n\nSingle Player – Test your skills across unique levels.\nTwo-Player Mode – Compete in quick place challenges and mini-games like Beach Ball, with more to come!\nThink you’ve got what it takes? Start now!",
      "instructions": "1st Player Controls : \nA, W, D -> Move, Space -> Place blocks \n\n2nd Player Controls:\nUp, Left, Right arrow keys -> Move, Left Mouse Click -> Place Blocks \n\nTip: First Jump, Release the Jump Key and then Place the Blocks! \n",
      "genres": [
        "Agility",
        "Puzzle"
      ],
      "tags": [
        "2players",
        "build",
        "cute",
        "jumping",
        "platformer"
      ]
    },
    "zh-CN": {
      "title": "空气方块",
      "description": "跳跃，放置方块，征服挑战关卡！\n\n在空中方块中，利用快速反应和巧妙的方块放置来克服障碍和敌人。每个关卡方块数量有限，每一步都至关重要！避开锯齿、尖刺，解锁门继续前进——如果能的话，还要抓取香蕉！\n\n游戏模式：\n\n单人模式 - 在独特的关卡中测试你的技能。\n双人模式 - 在快速放置挑战和海滩球等迷你游戏中竞争，更多内容即将到来！\n认为自己有这个能力吗？现在就开始吧！",
      "instructions": "1号玩家控制：\nA、W、D键 -> 移动，空格键 -> 放置方块\n\n2号玩家控制：\n上、左、右箭头键 -> 移动，左鼠标点击 -> 放置方块\n\n提示：第一次跳跃后，松开跳跃键，然后放置方块！",
      "genres": [
        "敏捷",
        "解谜"
      ],
      "tags": [
        "两人合作",
        "建造",
        "可爱",
        "跳跃",
        "平台游戏"
      ]
    },
    "zh-TW": {
      "title": "氣塊",
      "description": "跳躍、放置積木、征服挑戰等級！\n\n在空中積木遊戲中，利用敏捷的反應和巧妙的積木放置來克服障礙和敵人。每個等級的積木有限，每一步都至关重要！避免電鋸、釘刺並打開門來進行進行——還要盡可能地抓取香蕉！\n\n遊戲模式：\n\n單人模式 – 在獨特的等級中測試你的技巧。\n雙人模式 – 在快速放置挑戰和迷你遊戲（如沙灘排球）中競爭，更多內容將會陸續推出！\n你認為你有這個本領嗎？現在就開始吧！",
      "instructions": "1st Player 控制器：\nA, W, D -> 移動，空格鍵 -> 放置方塊\n\n2nd Player 控制器：\n上箭頭，左箭頭，右箭頭鍵 -> 移動，左鍵點擊 -> 放置方塊\n\n小技巧：第一次跳躍後，釋放跳躍鍵，再放置方塊！",
      "genres": [
        "敏捷度",
        "謎題"
      ],
      "tags": [
        "雙人遊玩",
        "建造",
        "可愛",
        "跳躍",
        "平台遊戲"
      ]
    },
    "zh-HK": {
      "title": "空氣塊",
      "description": "跳躍、放置積木、征服挑戰等級！\n\n在空中積木遊戲中，利用敏捷的反應和智慧地放置積木來克服障礙和敵人。每個等級的積木有限，每一步都至關重要！避免電鋸、釘刺並打開門來進行進行，還可以盡量抓取香蕉！\n\n遊戲模式：\n\n單人遊戲 – 在獨特等級中測試你的技能。\n雙人模式 – 在快速放置挑戰和迷你遊戲如沙灘排球中競爭，更多內容將會來臨！\n認為你有這個本領？現在就開始吧！",
      "instructions": "1st Player 控制：\nA、W、D -> 移動，空格 -> 放置方塊\n\n2nd Player 控制：\n上、左、右箭頭鍵 -> 移動，左鍵點擊 -> 放置方塊\n\n提示：第一個跳躍，放開跳躍鍵後再放置方塊！",
      "genres": [
        "靈敏度",
        "謎題"
      ],
      "tags": [
        "2玩家",
        "建造",
        "可愛",
        "跳躍",
        "平台遊戲"
      ]
    },
    "ja": {
      "title": "エアーブロック",
      "description": "ジャンプし、ブロックを配置し、挑戦的なレベルを制圧せよ！\n\nエアブロックで、素早い反応と賢いブロックの配置を使って障害物と敵を乗り越えよう。レベルごとに限られたブロックがあるので、一つ一つの動きが大切だ！サワーや棘、ドアを開放して進み、もしできるならバナナも手に入れよう！\n\nゲームモード：\n\nシングルプレイヤー – 独特のレベルであなたのスキルを試せ。\nツープレイヤーモード – クイックプレースチャレンジやビーチボールなどのミニゲームで競い合おう！これからもさらに追加される予定です！\n自分ができると感じたら、今すぐ始めよう！",
      "instructions": "1プレイヤーのコントロール：\nA, W, D -> 移動、スペースキー -> ブロックを配置\n\n2プレイヤーのコントロール：\n上、左、右の矢印キー -> 移動、左クリック -> ブロックを配置\n\nヒント：最初のジャンプ後、ジャンプキーを離し、その後ブロックを配置！",
      "genres": [
        "素早さ",
        "パズル"
      ],
      "tags": [
        "2プレイヤー",
        "建設",
        "可愛い",
        "ジャンプアクションプラットフォームゲーム"
      ]
    },
    "ko": {
      "title": "에어 블록",
      "description": "점프하고 블록을 배치하여 도전적인 레벨을克服하세요!\n\n에어블록에서는 신속한 반응과 지능적인 블록 배치로 장애물과 적을 극복하세요. 각 레벨별로 제한된 블록을 사용하여 모든 이동이 중요합니다! 도구와 지름신, 문을 열어 진행하세요—또한, 만들수 있는 경우 바나나를 가져오세요!\n\n게임 모드:\n\n단独行동 – 독특한 레벨에서 자신의 기술을 테스트하세요.\n이중 행동 모드 – 빠른 배치 도전과 비치볼과 같은 미니게임에서 경쟁하세요! 더 많은 게임이 추가됩니다!\n자신이 필요한 능력을 가지고 있다고 생각하시나요? 지금 시작하세요!",
      "instructions": "1번 플레이어 조작:\nA, W, D -> 이동, 공백 -> 블록 배치 \n\n2번 플레이어 조작:\n위, 왼쪽, 오른쪽 방향키 -> 이동, 왼쪽 마우스 클릭 -> 블록 배치 \n\n팁: 첫 번째 점프 후, 점프 키를 떼고 블록을 배치하세요!",
      "genres": [
        "민첩성",
        "퍼즐"
      ],
      "tags": [
        "2플레이어",
        "건설",
        "귀여운",
        "점프",
        "플랫폼 게임"
      ]
    },
    "fr": {
      "title": "Bloc d'air",
      "description": "Sautez, placez des blocs et conquérez des niveaux défiants !\n\nDans Air Block, utilisez des reflexes rapides et une placement de blocs intelligente pour surmonter les obstacles et les ennemis. Avec un nombre limité de blocs par niveau, chaque mouvement compte ! Évitez les scies, les épines et libérez les portes pour progresser—de plus, attrapez ces bananes si vous le pouvez !\n\nModes de jeu :\n\nJoueur unique – Testez vos compétences sur des niveaux uniques.\nMode deux joueurs – Competez dans des défis de placement rapide et des mini-jeux comme Beach Ball, avec plus à venir !\nPensez-vous avoir ce qu'il faut ? Commencez maintenant !",
      "instructions": "Contrôles du 1er joueur :\nA, W, D -> Déplacement, Espace -> Placer des blocs \n\nContrôles du 2e joueur :\nFlèches Haut, Gauche, Droite -> Déplacement, Clic Gauche de la souris -> Placer des blocs \n\nAstuce : Premier saut, relâchez la touche de saut et ensuite placez les blocs !",
      "genres": [
        "Agilité",
        "Puzzle"
      ],
      "tags": [
        "2 joueurs",
        "construction",
        "mignon",
        "saut",
        "plateformer"
      ]
    }
  }
};
